// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SearchWorkflowsRequestModel {
    static getAttributeTypeMap() {
        return SearchWorkflowsRequestModel.attributeTypeMap;
    }
}
SearchWorkflowsRequestModel.discriminator = undefined;
SearchWorkflowsRequestModel.attributeTypeMap = [
    {
        "name": "createdBefore",
        "baseName": "createdBefore",
        "type": "Date"
    },
    {
        "name": "createdAfter",
        "baseName": "createdAfter",
        "type": "Date"
    },
    {
        "name": "endBefore",
        "baseName": "endBefore",
        "type": "Date"
    },
    {
        "name": "endAfter",
        "baseName": "endAfter",
        "type": "Date"
    },
    {
        "name": "workflowTypes",
        "baseName": "workflowTypes",
        "type": "Array<string>"
    },
    {
        "name": "statusTypes",
        "baseName": "statusTypes",
        "type": "Array<string>"
    },
    {
        "name": "includePayors",
        "baseName": "includePayors",
        "type": "boolean"
    },
    {
        "name": "includePrescribers",
        "baseName": "includePrescribers",
        "type": "boolean"
    },
    {
        "name": "includePharmacies",
        "baseName": "includePharmacies",
        "type": "boolean"
    }
];
//# sourceMappingURL=searchWorkflowsRequestModel.js.map